module.exports = __webpack_public_path__ + "assets/c04cff53647c6bb89c6d8aaf781f1323.gif";